import { SearchableEhpadField } from "../../shared/components/SearchableEhpadField";
import { statusLabel } from "../../shared/controleConstants";
import { formatDate } from "../../shared/controleFormat";
import { CHARTER_COLORS as theme } from "../../shared/controleTheme";
import { tdStyle, thStyle } from "../../shared/styles/layoutStyles";

export function renderDossierList(view) {
    const { filteredDossiers, openDossier, workspace } = view;
    return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <div style={{ background: "white", border: `1px solid ${theme.border}`, borderRadius: "8px", padding: "14px", overflow: "visible" }}>
            <div style={{ display: "grid", gridTemplateColumns: "minmax(260px, 420px) auto", gap: "12px", alignItems: "end" }}>
                <div>
                    <label htmlFor="controle-classic-list-ehpad" style={{ display: "block", fontSize: "12px", color: theme.muted, marginBottom: "6px", fontWeight: 700 }}>EHPAD</label>
                    <SearchableEhpadField
                        id="controle-classic-list-ehpad"
                        ehpads={workspace.ehpads}
                        value={workspace.selectedEhpadId}
                        onChange={(id) => {
                            workspace.setSelectedEhpadId(id);
                            workspace.setActiveDossier(null);
                        }}
                        placeholder="Rechercher ou afficher tous"
                        allowClear
                    />
                </div>
                <div style={{ color: theme.muted, fontSize: "13px", paddingBottom: "8px" }}>
                    {workspace.selectedEhpadId
                        ? `${filteredDossiers.length} fiche${filteredDossiers.length > 1 ? "s" : ""} pour ${workspace.selectedEhpad?.nom || "cet EHPAD"}`
                        : `${filteredDossiers.length} fiche${filteredDossiers.length > 1 ? "s" : ""} au total`}
                </div>
            </div>
        </div>

        <div style={{ background: "white", border: `1px solid ${theme.border}`, borderRadius: "8px", overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                    <tr style={{ background: theme.surfaceMuted }}>
                        <th style={thStyle}>Date production</th>
                        <th style={thStyle}>EHPAD</th>
                        <th style={thStyle}>N° lot</th>
                        <th style={thStyle}>Statut</th>
                        <th style={thStyle}>Dernière modification</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredDossiers.map(dossier => (
                        <tr
                            key={dossier.id}
                            onClick={() => openDossier(dossier)}
                            onContextMenu={event => workspace.openContextMenu(event, dossier)}
                            title="Clic droit pour les actions"
                            style={{ cursor: "pointer" }}
                            onMouseEnter={e => e.currentTarget.style.background = theme.surfaceMuted}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                        >
                            <td style={tdStyle}>{formatDate(dossier.dateProduction)}</td>
                            <td style={tdStyle}>{dossier.ehpadNom}</td>
                            <td style={tdStyle}>{dossier.numeroLot}</td>
                            <td style={tdStyle}>{statusLabel(dossier.status)}</td>
                            <td style={tdStyle}>{dossier.updatedAt ? new Date(dossier.updatedAt).toLocaleString("fr-FR") : "—"}</td>
                        </tr>
                    ))}
                    {filteredDossiers.length === 0 && (
                        <tr>
                            <td colSpan={5} style={{ padding: "34px", textAlign: "center", color: theme.muted }}>
                                {workspace.selectedEhpadId ? "Aucune fiche pour cet EHPAD." : "Sélectionnez un EHPAD ou créez une fiche de contrôle."}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    </div>
    );
}
